/* Validation locale uniquement. L'envoi et la protection antispam restent Shopify. */
(() => {
  function init(scope) {
    scope.querySelectorAll('form').forEach(form => {
      const fields = [...form.querySelectorAll('[data-erreur]')];
      if (!fields.length || form.dataset.validationPrete) return;
      form.dataset.validationPrete = 'true';
      const validate = field => {
        const valid = field.validity.valid && (!field.required || field.value.trim().length > 0);
        field.setAttribute('aria-invalid', String(!valid));
        const error = document.getElementById(field.dataset.erreur);
        if (error) error.hidden = valid;
        return valid;
      };
      fields.forEach(field => {
        field.addEventListener('blur', () => validate(field));
        field.addEventListener('input', () => {
          if (field.getAttribute('aria-invalid') === 'true') validate(field);
        });
      });
      form.addEventListener('submit', event => {
        const invalid = fields.filter(field => !validate(field));
        if (!invalid.length) return;
        event.preventDefault();
        invalid[0].focus();
      });
      // Sans script, la validation HTML native reste active.
      form.noValidate = true;
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
